export const orderFillOrKillRequestsSchema = {
    id: '/OrderFillOrKillRequests',
    type: 'array',
    items: {
        properties: {
            signedOrder: {$ref: '/signedOrderSchema'},
            fillTakerAmount: {$ref: '/numberSchema'},
        },
        required: ['signedOrder', 'fillTakerAmount'],
        type: 'object',
    },
};



// WEBPACK FOOTER //
// ./~/0x.js/src/schemas/order_fill_or_kill_requests_schema.ts